import login from './login';

export const bootFunctions = {
    login: login.init,
};
